import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from "../shared/services/service";
import { Funcoes } from "../funcoes";

@Injectable()
export class MercadoInternoDefeitosService extends Service {
  protected url: string = this.dominio + "/adm/mercado-interno-mercadorias-defeitos/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  ordenaIndices(indices) {
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + 'ordenar', JSON.stringify(indices), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/mercado-interno-mercadorias/mercado-interno-defeitos.service.ts